<template>
  <div class="handle">
        <div class="title">手机三步操作<br/>轻松快速激活设备</div>
        <div class="write">首次注册仅需简单几步，杜绝繁琐步骤，轻松快速激活设备</div>
        <div class="ports">
            <div class="port"><div class="one"></div><div class="wt">扫码配套二维码</div></div>
            <div class="port"><div class="two"></div><div class="wt">注册账号</div></div>
            <div class="port"><div class="three"></div><div class="wt">完善门店信息</div></div>
        </div>
        <div class="small">更多详情请见维码器用户指南说明书</div>
    </div>
</template>

<script>
export default {
  name:'iphandle'
}
</script>

<style scoped>
    .handle{
        display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    box-sizing: border-box;
}
.handle .title{
font-size: 22px;
letter-spacing: 0px;
color: #000000;
margin-top: 50px;
text-align: center;
}
.handle .write{
font-size: 11px;
line-height: 11px;
color: #000000;
margin-top:14px;
}
.handle .ports{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 49px;
}
.handle .ports .port{
    height: 106px;
    width: 30%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.port .one{
    background: url(./images/01.svg) no-repeat;
    width: 75px;
	height: 75px;
    cursor: pointer;
    flex:1;
}
.port .two{
    background: url(./images/02.svg) no-repeat;
    width: 75px;
	height: 75px;
    cursor: pointer;
    flex:1;
}
.port .three{
    background: url(./images/03.svg) no-repeat;
    width: 75px;
	height: 75px;
    cursor: pointer;
    flex:1;
}
.port .wt{
    font-size: 12px;
	letter-spacing: 0px;
	color: #000000;
}
.port:hover .wt{
    color: #198bfe;
}
.port .one:hover{
    background: url(./images/1.svg) no-repeat;
    width: 75px;
	height: 75px;
}
.port .two:hover{
    background: url(./images/2.svg) no-repeat;
    width: 75px;
	height: 75px;
}
.port .three:hover{
    background: url(./images/3.svg) no-repeat;
   width: 75px;
	height: 75px;
}
.small{
    font-size: 11px;
    margin-top: 47px;
    margin-bottom: 50px;
    color: #999;
}
</style>





// WEBPACK FOOTER //
// src/components/hardProduct/iphandle.vue